// extracted by mini-css-extract-plugin
export default {"Content":"ChangeArchiveFullView_Content__M2--Y"};